import { ThemeConfig } from 'antd';

// Modern corporate logistics theme configuration
export const corporateTheme: ThemeConfig = {
  token: {
    // Primary Colors - Refined Corporate Indigo/Blue
    colorPrimary: '#2563eb',
    colorPrimaryHover: '#1d4ed8',
    colorPrimaryActive: '#1e40af',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#2563eb',
    
    // Background Colors
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f8fafc',
    
    // Text Colors - High contrast, slate modern palette
    colorText: '#0f172a',
    colorTextSecondary: '#64748b',
    colorTextTertiary: '#94a3b8',
    colorTextQuaternary: '#cbd5e1',
    
    // Border Colors
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#f1f5f9',
    
    // Font - Inter / Modern SaaS System Stack
    fontFamily: '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    fontSizeLG: 15,
    fontSizeSM: 13,
    fontSizeXL: 18,
    
    // Border Radius - Crisp modern radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    borderRadiusXS: 4,
    
    // Spacing
    sizeStep: 4,
    sizeUnit: 4,
    
    // Control Height
    controlHeight: 36,
    controlHeightLG: 42,
    controlHeightSM: 28,
    
    // Line Height
    lineHeight: 1.5,
    lineHeightLG: 1.5,
    lineHeightSM: 1.4,
    
    // Box Shadow - Subtle multi-layer soft shadows
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05)',
    boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -2px rgba(0, 0, 0, 0.05)',
    
    // Motion
    motionDurationFast: '0.15s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
  },
  components: {
    // Layout
    Layout: {
      bodyBg: '#f8fafc',
      headerBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
      siderBg: '#0f172a',
      triggerBg: '#1e293b',
      triggerColor: '#ffffff',
    },
    
    // Menu
    Menu: {
      itemBg: 'transparent',
      itemHoverBg: 'rgba(255, 255, 255, 0.06)',
      itemSelectedBg: '#2563eb',
      itemSelectedColor: '#ffffff',
      itemActiveBg: 'rgba(37, 99, 235, 0.15)',
      itemHoverColor: '#ffffff',
      itemColor: '#94a3b8',
      subMenuItemBg: 'transparent',
      darkItemBg: 'transparent',
      darkItemColor: '#94a3b8',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.06)',
      darkItemSelectedBg: '#2563eb',
      darkItemSelectedColor: '#ffffff',
      darkSubMenuItemBg: 'transparent',
      itemBorderRadius: 8,
      itemMarginInline: 8,
    },
    
    // Button
    Button: {
      primaryShadow: '0 1px 2px 0 rgba(37, 99, 235, 0.3)',
      defaultShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.04)',
      fontWeight: 500,
      borderRadius: 8,
      controlHeight: 36,
      controlHeightLG: 42,
      controlHeightSM: 28,
    },
    
    // Input
    Input: {
      activeBorderColor: '#2563eb',
      hoverBorderColor: '#60a5fa',
      borderRadius: 8,
      paddingInline: 12,
      paddingBlock: 7,
    },
    
    // Card - Enterprise clean container
    Card: {
      borderRadiusLG: 12,
      paddingLG: 20,
      headerBg: 'transparent',
      headerHeight: 52,
      actionsBg: '#ffffff',
    },
    
    // Table
    Table: {
      borderRadius: 10,
      headerBg: '#f8fafc',
      headerColor: '#475569',
      rowHoverBg: '#f1f5f9',
      borderColor: '#e2e8f0',
      cellPaddingBlock: 12,
      cellPaddingInline: 14,
    },
    
    // Form
    Form: {
      labelColor: '#1e293b',
      labelFontSize: 13,
      itemMarginBottom: 20,
    },
    
    // Modal - Modern compact
    Modal: {
      borderRadiusLG: 16,
      headerBg: '#ffffff',
      titleFontSize: 18,
      titleLineHeight: 1.4,
    },
    
    // Drawer
    Drawer: {
      borderRadius: 12,
    },
    
    // Select
    Select: {
      borderRadius: 8,
      optionSelectedBg: '#eff6ff',
      controlHeight: 36,
    },
    
    // Tabs
    Tabs: {
      itemActiveColor: '#2563eb',
      itemHoverColor: '#3b82f6',
      itemSelectedColor: '#2563eb',
      inkBarColor: '#2563eb',
    },
    
    // Tag
    Tag: {
      borderRadius: 6,
      fontSize: 12,
    },
    
    // Typography
    Typography: {
      titleMarginBottom: '0.4em',
      titleMarginTop: '1em',
    },
  },
};


